import React from 'react';
import {makeStyles} from "@mui/styles";
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import {TextField as MuiTextField} from "@mui/material";
import {TextField} from "mui-rff";
import IconButton from "../button/icon_button";
import {Close} from '@mui/icons-material';
import classnames from "classnames";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '5px 15px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        color: theme.vars.palette.background.paper,
        backgroundColor: props => props.form ? theme.vars.palette.background.paper : "",
        boxShadow: 'none',
        // boxShadow: props => props.shadow ? `0px 7px 7px ${theme.vars.palette['app-specific'].shadow}` : 'none',
        '& .MuiInputBase-formControl': {
            margin: 16,
        },
    },
    input: {
        flex: 1,
        color: theme.vars.palette.background.paper,
        backgroundColor: props => props.form ? theme.vars.palette.background.paper : "",
    },
    innerInput: {
        borderRadius: 10,
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&:focus': {
            backgroundColor: 'transparent',
        },
    },
    divider: {
        height: 25,
        margin: 4,
        width: 1,
        color: theme.vars.palette.divider,
    },
}));

export const Input = ({
                          className,
                          placeholder = 'type...',
                          label,
                          ariaLabel = 'input',
                          value,
                          onChange,
                          type = 'text',
                          variant = 'standard',
                          shadow = true,
                          canClear = true,
                          InputProps,
                          ...props
                      }) => {
    const classes = useStyles({shadow});
    const clearInput = () => {
        if (onChange) onChange('');
    }

    return (
        <Paper className={classnames(classes.root, 'input-with-paper')}>
            <MuiTextField
                type={type}
                variant={variant}
                label={label}
                name={label}
                value={value}
                onChange={(e) => onChange && onChange(e.target.value)}
                className={`${classes.input} ${className}`}
                placeholder={placeholder}
                InputProps={variant === 'standard' ? {disableUnderline: true, ...InputProps} : {...InputProps}}
                inputProps={{'aria-label': ariaLabel}}
                {...props}
            />
            {
                canClear && value?.length > 0 &&
                <>
                    <Divider className={classes.divider} orientation="vertical"/>
                    <IconButton
                        onPressed={clearInput}
                        color={'paper.secondary'}
                    >
                        <Close/>
                    </IconButton>
                </>
            }
        </Paper>
    );
}


export const InputForm = ({
                              value,
                              placeholder = 'type...',
                              label,
                              ariaLabel = 'input',
                              onChange,
                              type,
                              required = false,
                              fullWidth = true,
                              helperText,
                              name,
                              shadow = true,
                              paperClassName = '',
                              ...props
                          }) => {
    const classes = useStyles({shadow, form: true});

    const clearInput = () => {
        if (onChange) {
            switch (type) {
                case 'number' :
                    onChange(undefined);
                    break;
                default:
                    onChange(undefined);
                    break;

            }
        }
    }

    return (
        <Paper className={classnames(classes.root, paperClassName, 'input-with-paper')}>
            <TextField
                helperText={helperText}
                fullWidth={fullWidth}
                required={required}
                type={type}
                variant={'standard'}
                label={label}
                name={name}
                {...(!!onChange ? {onChange: (e) => onChange(e.target.value)} : {})}
                classes={{root: classes.innerInput}}
                className={classes.input}
                placeholder={placeholder}
                InputProps={{disableUnderline: true}}
                inputProps={{'aria-label': ariaLabel}}
                {...props}
            />
            {value && value.length &&
                <>
                    <Divider className={classes.divider} orientation="vertical"/>
                    <IconButton
                        onPressed={clearInput}
                        color={'paper.secondary'}
                    >
                        <Close/>
                    </IconButton>
                </>
            }

        </Paper>
    );
}
